import Http from "./base-http";

class Admin extends Http {
  assignOrRevokeAdminRights(data) {
    return this.client.post('processadminrights', data);
  }
}
const admin = new Admin({
  modelUrlPrefix : "admin"
});

export default admin;
